const FILTER_TYPE = {
  DATE: 'date',
  MONTH: 'month',
};

export { FILTER_TYPE };
